package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.lizergy.model.stumps.StartupOperations
import store.PlannerClientState

/**
 * Updates a single project.
 * Does *not* navigate to the project
 */
data class UpdateStartupOperationsAction(val projectId: PhotovoltaicsProjectId, val updatedStartupOperations: StartupOperations) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    println("Updating StartupOperations <${updatedStartupOperations.uuid}> for project <${projectId}>")

    val resolvedProject = this.resolvedProjects[projectId]
    val updatedProject = resolvedProject.copy(startupOperations = updatedStartupOperations)

    val updatedProjects = this.resolvedProjects.withUpdated(updatedProject)

    return this.copy(resolvedProjects = updatedProjects)
  }
}
